module.exports = __webpack_public_path__ + "static/60-coaches-sm-de30ba7bc385db2a5a9c51040e48744f.jpg";